import { useLocalSearchParams } from 'expo-router'

import FosterDocumentsCard from '@/components/fosters/cards/FosterDocumentsCard'
import FosterTab from '@/components/fosters/FosterTab'
import useFosterOwner from '@/hooks/useFosterOwner'
import { useAppStore } from '@/store/useAppStore'

const FosterDocumentsTab = () => {
  const { id: fosterId } = useLocalSearchParams<{ id: string }>()
  const isFosterOwner = useFosterOwner(fosterId)
  const currentOrganization = useAppStore.use.currentOrganization().organization
  const isDisabled = !currentOrganization?.subscriptionActive || !isFosterOwner

  return (
    <FosterTab fosterId={fosterId} viewId="foster-documents-tab">
      <FosterDocumentsCard disabled={isDisabled} fosterId={fosterId} />
    </FosterTab>
  )
}

export default FosterDocumentsTab
